// extracted by mini-css-extract-plugin
module.exports = {"Author":"Author_Author___BWqp","Author__heading":"Author_Author__heading__TmzP0"};